const getTokenCurrentUser = () => {
    const currentUser = localStorage.getItem('currentUser')
    if (currentUser){
      const ls = JSON.parse(currentUser)
      return ls.token
    }
    return null
}

export {
    getTokenCurrentUser
}